import React from 'react';
import classNames from 'classnames';
import styles from '../slide.css';
import connect from '@src/js/separate-logic/connect';
import SlideComponentModel from './slide-component-model';
import SlidePresenter from './slide-presenter';
import ElementWrapper from '../element-wrapper';

interface ISlideProps {
    // 父组件props
    isShown: boolean;
    slideModel: any;
    slideWidth: number;
    slideHeight: number;
    region: any;
    scale?: number;
    getPageScale: () => number;
    mobileEditMode: () => boolean;
    index: number;

    // model props
    taskGroup: any;

    // dispatchFun
    setDomRef: (key, ref) => void;
    setWrapperRef: (key, ref) => void;

    setRef: (name: string, ref: any) => void;
    setPathRef: (key, ref) => void;
}

export class Slide extends React.Component<ISlideProps> {
    public static displayName = 'Slide';

    public static defaultProps = {
        setRef: () => {
            // 处理domRef，增加注释，以便于符合no-empty-function校验规则
        },
    };

    public render() {
        const { slideModel, isShown, setRef } = this.props;

        const classes = classNames({
            [styles.slide]: true,
            currentSlide: isShown,
            [styles.slideUndisplay]: !isShown,
            [styles['slide-dom-compatible']]: true,
        });
        const style = { ...slideModel.props.style, background: 'transparent' };

        return (
            <div
                ref={ref => setRef('containerRef', ref)}
                className={classes}
                style={style}
                id={`slide-${slideModel.key}`}
            >
                {slideModel?.children.map(this.renderChild)}
            </div>
        );
    }

    private renderChild = (childObj) => {
        const { slideModel, getPageScale, region, taskGroup, setDomRef,
            setWrapperRef, setPathRef } = this.props;

        return (
            <ElementWrapper
                domRefCallback={(ref) => {
                    setDomRef(childObj.key, ref);
                }}
                ref={(ref) => {
                    setWrapperRef(childObj.key, ref);
                }}
                getPageScale={getPageScale}
                key={childObj.key}
                element={childObj}
                fromScale={0}
                relativeRotate={0}
                relativeFlipH={0}
                relativeFlipV={0}
                region={region}
                displayElement={slideModel.displayChildrenElement}
                taskGroup={taskGroup && !taskGroup.isFinished ? taskGroup : null}
                waitGroupComplete={true}
                event={{}}
                componentName={'ElementWrapper'}
                mobileEditMode={this.props.mobileEditMode ? this.props.mobileEditMode : () => undefined}
                setPathRef={setPathRef}
            />
        );
    };
}

export default connect(
    SlidePresenter,
    SlideComponentModel,
    Slide,
);
